import React from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";
import ContactLists from "./components/ContactLists";
import Button from "./components/Button";
import Pagenation from "./components/Pagenation";
import Heading from "./components/Heading";
import ContactContextProvider from "./context/ContactContextProvider";

function App() {
  return (
    <ContactContextProvider>
      <div className="container">
        <Button />
        <div className="contacts-wrapper">
          <Heading />
          <Routes>
            <Route path="/" element={<ContactLists />} />
            <Route path="/page/:pageNo" element={<ContactLists />} />
          </Routes>
        </div>
        <Pagenation />
      </div>
    </ContactContextProvider>
  );
}

export default App;
